import React from 'react';
import { Box, Chip } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import { guaranteesApplicationStatusStyles } from '../guaranteesApplicationStatusStyles.ts';
import type { TStatusFlowNode } from './types.ts';
import { getStatusColor, getStatusLabel } from './utils.ts';

interface IStatusFlowNodeProps {
  node: TStatusFlowNode;
}

const StatusFlowNode: React.FC<IStatusFlowNodeProps> = ({ node }) => {
  const label = getStatusLabel(node.status);

  return (
    <Box component="span" sx={guaranteesClientPageStyles.statusFlowNode}>
      <Chip
        label={label}
        color={getStatusColor(node.status)}
        size="small"
        variant="filled"
        sx={guaranteesApplicationStatusStyles.chip}
      />
    </Box>
  );
};

export default StatusFlowNode;
